import { cacheDom } from "../utils/QuerySelectors.js"
import { setCartOpen } from '../apps/store/cartSlice'
import store from '../apps/store/store'

const state = {
  mobileMenuOpen: false,
  desktopMenuOpen: false,
}
const dom = {}
const qs = {
  stickyHeader: 'data-sticky-header',
  desktopPanel: 'data-desktop-panel',
  desktopPanelInner: 'data-desktop-panel-inner',
  desktopClose: 'data-desktop-panel-close',
  desktopMenuGroup: 'data-megamenu-group',
  desktopDetails: 'data-desktop-details',
  navImage: 'data-nav-image',
  mainImage: 'data-main-image',
  hoverImage: 'data-hover-image',
  navActive: 'data-nav-active',
  mobilePanel: 'data-mobile-panel',
  mobilePanelInner: 'data-mobile-panel-inner',
  mobileNav: 'data-mobile-nav',
  mobileSearch: 'data-megamenu-handle="search"',
  bannerClose: 'data-banner-close',
  accountNav: 'data-header-account-nav',
}
const qsAll = {
  parents: 'data-parent-handle',
  children: 'data-child',
  secondNavs: 'data-second',
  navPanels: 'data-megamenu-handle',
  mobileBtns: 'data-header-mobile-btn',
  searchBtns: 'data-header-search',
  cartBtns: 'data-cart-open',
  times: 'data-newyork-time',
  accountBtns: 'data-header-account',
}

const scrollEvent = () => {
  const offSet = location.pathname == '/' ? 450 : 80
  if(window.pageYOffset > offSet)
    dom.stickyHeader.classList.add('header-sticky')
  else
    dom.stickyHeader.classList.remove('header-sticky')
  if(state.desktopMenuOpen || state.mobileMenuOpen) dom.stickyHeader.classList.add('header-sticky')
}

const openDesktopPanel = (handle) => {
  dom.desktopPanel.classList.add('z-50', '!opacity-100')
  dom.desktopPanel.classList.remove('z-[-1]', 'opacity-0')

  dom.desktopPanelInner.classList.add('left-0')
  dom.desktopPanelInner.classList.remove('left-[-44.5rem]')

  document.body.classList.add('overflow-hidden')
  
  const navPanel = dom.desktopDetails.querySelector(`[${qsAll.navPanels}="${handle}"]`)
  const allPanels = dom.desktopDetails.querySelectorAll(`[${qsAll.navPanels}]`)
  if(navPanel) {
    allPanels.forEach((panel) => {
      panel.classList.add('hidden')
    })
    navPanel.classList.remove('hidden')
    if(handle == 'search') navPanel.querySelector('[data-search-box]').focus()
  }
  state.desktopMenuOpen = true 
}

const closeDesktopPanel = () => {
  dom.desktopPanel.classList.remove('z-50', '!opacity-100')
  dom.desktopPanel.classList.add('z-[-1]', 'opacity-0')

  dom.desktopPanelInner.classList.remove('left-0')
  dom.desktopPanelInner.classList.add('left-[-44.5rem]')

  document.body.classList.remove('overflow-hidden')
  state.desktopMenuOpen = false
}

const updateSecondNav = (element) => {
  const parent = element.closest(`[${qsAll.secondNavs}]`)
  const imageUrl = typeof element.dataset.image != 'undefined' ? element.dataset.image : null
  const navImage = parent.querySelector(`[${qs.navImage}]`)
  const hoverImage = parent.querySelector(`[${qs.hoverImage}]`)
  const mainImage = parent.querySelector(`[${qs.mainImage}]`) 
  const navActive = parent.querySelector(`[${qs.navActive}]`) 
  if(navImage && imageUrl) {
    if(hoverImage) hoverImage.remove()
    navImage.innerHTML += `<img class="w-full h-full object-cover absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" src="${imageUrl}" data-hover-image />`
    if(mainImage) mainImage.classList.add('opacity-0')
  }
  if(navActive) navActive.innerHTML = element.innerHTML
}

const clearSecondNav = (element) => {
  const parent = element.closest(`[${qsAll.secondNavs}]`)
  const hoverImage = parent.querySelector(`[${qs.hoverImage}]`)
  const mainImage = parent.querySelector(`[${qs.mainImage}]`)
  const navActive = parent.querySelector(`[${qs.navActive}]`)
  if(hoverImage) hoverImage.remove()
  if(mainImage) mainImage.classList.remove('opacity-0')
  if(navActive) navActive.innerHTML = ''
}

const openMobilePanel = (panelType = 'menu') => {
  dom.mobilePanel.classList.add('z-50', '!opacity-100')
  dom.mobilePanel.classList.remove('z-[-1]', 'opacity-0')

  dom.mobilePanelInner.classList.add('left-0')
  dom.mobilePanelInner.classList.remove('left-[-20rem]')

  document.body.classList.add('overflow-hidden')
  dom.stickyHeader.classList.add('header-sticky', '!bg-white', '!text-black')

  if(panelType == 'menu') {
    dom.mobileNav.classList.add('flex')
    dom.mobileNav.classList.remove('hidden')
    
    dom.mobileSearch.classList.remove('block')
    dom.mobileSearch.classList.add('hidden')
  } else {
    dom.mobileNav.classList.remove('flex')
    dom.mobileNav.classList.add('hidden')
    
    dom.mobileSearch.classList.add('block')
    dom.mobileSearch.classList.remove('hidden')
  }
  state.mobileMenuOpen = true
}
const closeMobilePanel = () => {
  dom.mobilePanel.classList.remove('z-50', '!opacity-100')
  dom.mobilePanel.classList.add('z-[-1]', 'opacity-0')

  dom.mobilePanelInner.classList.remove('left-0')
  dom.mobilePanelInner.classList.add('left-[-20rem]')

  document.body.classList.remove('overflow-hidden')
  dom.stickyHeader.classList.remove('header-sticky', '!bg-white', '!text-black')
  dom.mobileBtns.forEach((btn) => {  
    btn.innerHTML = 'Menu'
    btn.classList.remove('active')
  })
  dom.mobileNav.classList.remove('flex')
  dom.mobileNav.classList.add('hidden')
  
  dom.mobileSearch.classList.remove('block')
  dom.mobileSearch.classList.add('hidden')
  state.mobileMenuOpen = false
}

const setupTimers = () => {
  if(dom.times.length > 0) {
    setInterval(() => {
      if(typeof moment != 'undefined') {
        const currentTime = moment().tz('America/New_York').format('hh:mma')
        dom.times.forEach((timeElement) => {
          timeElement.innerHTML = currentTime
        })
      }
    }, 1000)
  }
}

const resizeEvent = () => {
  window.innerWidth >= 1024 ? closeMobilePanel() : closeDesktopPanel()
  if(state.desktopMenuOpen || state.mobileMenuOpen) document.body.classList.add('overflow-hidden')
}

export const setupHeader = () => {
  cacheDom(dom, qs, qsAll)
  window.addEventListener("scroll", scrollEvent)

  // Desktop
  dom.parents.forEach((parent) => {
    parent.addEventListener('mouseover', (e) => {
      const handle = e.target.dataset.parentHandle
      openDesktopPanel(handle)
    })
  })
  dom.desktopPanel.addEventListener('click', () => {
    closeDesktopPanel()
  })
  dom.desktopClose.addEventListener('click', () => {
    closeDesktopPanel()
  })
  dom.desktopPanelInner.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.desktopMenuGroup.querySelectorAll('[data-megamenu-handle]').forEach((megamenu) => {
    dom.desktopDetails.append(megamenu)
  })
  dom.desktopDetails.querySelectorAll(`[${qsAll.children}]`).forEach((child) => {
    child.addEventListener('mouseenter', (e) => {
      updateSecondNav(e.target)
    })
    child.addEventListener('mouseleave', (e) => {
      clearSecondNav(e.target)
    })
  })

  // Mobile
  dom.mobileSearch = dom.mobilePanel.querySelector(`[${qs.mobileSearch}]`)
  dom.mobileBtns.forEach((mobileBtn) => {
    mobileBtn.addEventListener('click', () => {
      mobileBtn.classList.toggle('active')
      if(mobileBtn.classList.contains('active')) {
        mobileBtn.innerHTML = 'Close'
        openMobilePanel()
      } else {
        mobileBtn.innerHTML = 'Menu'
        closeMobilePanel()
      }
      dom.mobileBtns.forEach((btn) => {
        if(mobileBtn.classList.contains('active')) {
          btn.innerHTML = 'Close'
          btn.classList.add('active')
        } else {
          btn.innerHTML = 'Menu'
          btn.classList.remove('active')
        }
      })
    })
  })
  dom.mobilePanel.addEventListener('click', () => {
    closeMobilePanel()
  })
  dom.mobilePanelInner.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  window.addEventListener('resize', () => {
    window.innerWidth >= 1024 ? closeMobilePanel() : closeDesktopPanel()
    if(state.desktopMenuOpen || state.mobileMenuOpen) document.body.classList.add('overflow-hidden')
  }, true)

  if(typeof screen.orientation != 'undefined') {
    screen.orientation.addEventListener('change', () => {
      resizeEvent()
    })
  } else {
    window.addEventListener("orientationchange", () => {
      resizeEvent()
    })
  }

  // Search
  dom.searchBtns.forEach((searchBtn) => {
    searchBtn.addEventListener('click', () => {
      openMobilePanel('search')
    })
  })

  // Cart Buttons
  dom.cartBtns.forEach((cartBtn) => {
    cartBtn.addEventListener('click', () => {
      store.dispatch(setCartOpen(true))
    })
  })

  // Banner Close
  if(dom.bannerClose) {
    dom.bannerClose.addEventListener('click', (e) => {
      e.target.closest('.header-index-announcement').remove()
      Cookies.set('announcement-banner', true, { expires: 30 })
    })
  }
  setupTimers()

  // Account Navs
  dom.accountBtns.forEach((accountBtn) => {
    accountBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      const accountNav = e.target.closest('.header-actions').querySelector(`[${qs.accountNav}]`)
      if(accountNav) {
        accountNav.classList.toggle('!opacity-100')
        accountNav.classList.toggle('!z-[1]')
        accountNav.classList.toggle('!pointer-events-auto')
      }
    })
  })
  window.addEventListener("click", () => {
    dom.accountBtns.forEach((accountBtn) => {
      const accountNav = accountBtn.closest('.header-actions').querySelector(`[${qs.accountNav}]`)
      if(accountNav) {
        accountNav.classList.remove('!opacity-100')
        accountNav.classList.remove('!z-[1]')
        accountNav.classList.remove('!pointer-events-auto')
      }
    })
  })
}